import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type { TxmonItem, ThresholdConfigMap } from './types';

interface TxmonItemsState {
  items: TxmonItem[];
  thresholdsConfig: ThresholdConfigMap;
  txmonItemsLoaded: boolean;
  thresholdsConfigLoaded: boolean;
}

const initialState: TxmonItemsState = {
  items: [],
  thresholdsConfig: { accounts: {} },
  txmonItemsLoaded: false,
  thresholdsConfigLoaded: false,
};

const txmonItemsSlice = createAppSlice({
  name: 'txmonItems',
  initialState,
  reducers: {
    setTxmonItems: (state, action: PayloadAction<TxmonItem[]>) => {
      state.items = action.payload;
      state.txmonItemsLoaded = true;
    },
    setThresholdsConfig: (state, action: PayloadAction<ThresholdConfigMap>) => {
      state.thresholdsConfig = action.payload;
      state.thresholdsConfigLoaded = true;
    },
    txmonItemsReset: () => initialState,
  },
});

export const { setTxmonItems, setThresholdsConfig, txmonItemsReset } =
  txmonItemsSlice.actions;
export default txmonItemsSlice.reducer;
